import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CustomersView } from "src/components/views/erp/sales/customer/CustomersView.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/sales/customers")({
	staticData: { title: i18n.t("customers"), legacyViewKey: "customersPage" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <CustomersView isActive={isActive} />;
}
